import { useMemo } from 'react';
import { useLocalStorageState } from '@clover-util/use-storage-state';
import { useMerchant } from './context/merchant';
import { DateTime } from 'luxon';
import { DurationLike } from 'luxon/src/duration';

export function useStorageExpiry(keyGenerator: (merchantId: string) => string): [boolean, () => void] {
  const { merchant } = useMerchant();
  const merchantId = merchant?.merchantUuid;

  const [updatedOn, setUpdatedOn] = useLocalStorageState<number | undefined>((merchantId && keyGenerator(merchantId)) || undefined, () => {
    return Date.now();
  });

  const isExpired = useMemo(() => {
    if (!merchantId) return false;
    if (!updatedOn) return true;

    return DateTime.fromMillis(updatedOn) < DateTime.now().minus({ hours: 8 });
  }, [merchantId, updatedOn]);

  const updateExpiry = useMemo(() => () => {
    setUpdatedOn(Date.now());
  }, [setUpdatedOn]);

  return [isExpired, updateExpiry];
}

export function useCustomerStorageExpiry(key: string, timeToExpiration: DurationLike): [boolean, () => void] {
  const [updatedOn, setUpdatedOn] = useLocalStorageState<number | undefined>(key || undefined, () => {
    return Date.now();
  });

  const isExpired = useMemo(() => {
    if (!updatedOn) return true;

    return DateTime.fromMillis(updatedOn) < DateTime.now().minus(timeToExpiration);
  }, [updatedOn, timeToExpiration]);

  const updateExpiry = useMemo(() => () => {
    setUpdatedOn(Date.now());
  }, [setUpdatedOn]);

  return [isExpired, updateExpiry];
}

